/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import get from 'lodash/get';
import moment from 'moment';
import { useMe } from 'modules/company/hooks/useCompanySelector';
import { validateInvitationCode } from '../api';
import React from 'react';

const INITIAL_STATE = {
  loading: false,
  validated: false,
  expired: false,
  existed: false,
  error: '',
};

export const useValidateInvitationCode = (invitationCode, currentEmail) => {
  const [validationState, setValidationState] = useState(INITIAL_STATE);

  const validateCode = async (code) => {
    try {
      setValidationState({
        ...INITIAL_STATE,
        loading: true,
      });
      const { data: response, errorObj } = await validateInvitationCode(code || invitationCode);
      if (response) {
        setValidationState({
          ...validationState,
          data: {
            ...response?.data,
          },
          existed: response?.data?.hasAccount,
          validated: true,
          loading: false,
          expired: false,
        });

        return;
      }
      if (errorObj) {
        throw errorObj;
      }
    } catch (error) {
      setValidationState({
        ...INITIAL_STATE,
        loading: false,
        validated: true,
        expired: true,
      });
      throw error;
    }
  };

  React.useEffect(() => {
    if (invitationCode) {
      validateCode();
    }
  }, [invitationCode]);

  return {
    ...validationState,
  };
};
